import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription } from 'rxjs';
import { CustomLoadingService } from '../custom-loading/custom-loading.service';
import { LoaderState } from "../../interface/loader-state"
@Component({
    selector: 'app-custom-loading',
    templateUrl: './custom-loading.component.html',
    styleUrls: ['./custom-loading.component.css'],

})

export class CustomLoadingComponent implements OnInit, OnDestroy {
    show = false;
    message = ""
    private subscription: Subscription;

    constructor(private translateService: TranslateService,
        private loaderService: CustomLoadingService
    ) {


    }
     reportType: number
    ngOnInit() {
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
                this.reportType = state.reportType;
                this.message = this.translateService.instant("Reports.ReportGenerationMessage");
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}
